import CHAT_MANAGEMENT_EXPERIENCE_TYPES from '../../../types/experiences/ChatManagement'

const initialState = {
  chatGroupId: null,
  userId: null,
  deviceId: null,
  subscribed: false
}

export default function chatManagementActiveContextReducer (state = initialState, action) {
  switch (action.type) {
    case CHAT_MANAGEMENT_EXPERIENCE_TYPES.SUBSCRIBE_CONTEXT:
      return {
        chatGroupId: action.data.chatGroupId || null,
        userId: action.data.userId || null,
        deviceId: action.data.deviceId || null,
        subscribed: true
      }
    case CHAT_MANAGEMENT_EXPERIENCE_TYPES.UNSUBSCRIBE_CONTEXT:
      return initialState
    default:
      return state
  }
}
